import {ContentItem} from "@api";
import * as C from "@/components";
import React from "react";
import VadImage from "vadimages-nextjs-image-optimizer";

export interface AvailableSizesCardProps {
    pageContent: Record<string, ContentItem>;
    imageDirectory: string;
}

export const AvailableSizesCard = ({ pageContent, imageDirectory }: AvailableSizesCardProps) => {
    return (
      <C.Card className='m-3 w-full relative' style={{ padding: 0 }}>
          <div className="w-full md:w-fit md:float-end">
              <div className='block md:hidden space-y-7 text-center p-10'>
                  <p className='font-semibold text-4xl'>
                      {pageContent["available-sizes.headline"]?.data ?? ""}</p>
                  <p>{pageContent["available-sizes.subhead"]?.data ?? ""}</p>
                  <C.PageLink className={`inline-block`} href="#contact-us" data-logic-feature="scroll-to" data-scroll-to="contact-us" variant={C.PageLinkVariant.RoundedBorderButton}>
                      {pageContent["available-sizes.link"]?.data ?? ""}
                  </C.PageLink>
              </div>
              <div className='pb-12 pr-8 md:p-14 md:pr-20 items-center justify-center gap-0 sm:gap-10 flex text-center [&>*]:max-w-[100px]'>
                  <div className="relative ml-2 min-[425px]:ml-2 min-[500px]:ml-1 md:ml-5">
                      <p>Standard 10.5mm</p>
                      <C.OrangeArrow height={72} />
                  </div>
                  <div className="relative ml-1 min-[425px]:ml-3 min-[500px]:ml-8 min-[600px]:ml-14 md:ml-5">
                      <p>XL 13mm</p>
                      <C.OrangeArrow height={72} />
                  </div>
              </div>
              <div className='hidden md:block'>
                  <VadImage
                      src={`${imageDirectory}available-sizes.png`}
                      alt='Available sizes'
                      width={549}
                      height={502}
                      className='max-md:w-full'
                  />
              </div>
              <div className='block md:hidden'>
                  <VadImage
                      src={`${imageDirectory}mobile/available-sizes.png`}
                      alt='Available sizes'
                      width={549}
                      height={502}
                      className='max-md:w-full'
                  />
              </div>
          </div>
          <div className="hidden md:block absolute space-y-7 top-1/2 -translate-y-1/2 md:left-8 lg:left-28">
              <p className='font-semibold text-4xl md:max-w-[350px] lg:max-w-[549px]'>
                  {pageContent["available-sizes.headline"]?.data ?? ""}</p>
              <p>{pageContent["available-sizes.subhead"]?.data ?? ""}</p>
              <C.PageLink className={`inline-block`} href="#contact-us" data-logic-feature="scroll-to" data-scroll-to="contact-us" variant={C.PageLinkVariant.RoundedBorderButton}>
                  {pageContent["available-sizes.link"]?.data ?? ""}
              </C.PageLink>
          </div>
      </C.Card>
    );
};
